import React, { useEffect, useRef, useState } from 'react'
import TitleNoteCommon from '../home/generate/TitleNoteCommon'
import { FormGroup, Input, Label } from 'reactstrap';
import Select from 'react-select'
import { Controller } from 'react-hook-form'
import { listChatGpt, interactionLanguages, interactionMethods, listVoiceEngage } from '@utils/dataDefault'
import { BookListFile } from '../home/generate'
import { Icon } from '@components/common'
import { UploadComponent } from '../ReferenceMedia/ModalMedia/UploadCustom';
import ImageUser from '@images/common/no-avatar.jpg';
import ArrowLeft from '@images/common/arrow-left.svg';
import ArrowRight from '@images/common/arrow-right.svg';
import styled from 'styled-components';

const WrapSelectAvatar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: scroll;
  scroll-behavior: smooth;
  .arrow-left {    
    position: absolute;
    top: 110px;
    left: -30px;
  }
  .arrow-right {    
    position: absolute;
    top: 110px;
    right: -30px;
  }
`

const WrapItemCharacter = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  border: ${(props) => (props.isActive ? "1px solid #0089C2" : "1px solid #D0D5DD")};
  box-shadow: ${(props) => (props.isActive ? "0px 0px 0px 4px #006E9B1F" : "none")};
  border-radius: 8px;
  cursor: pointer;
  .character__check {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .character__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #081B2A;
    &-img {
      width: 80px;
      height: 80px;
      overflow: hidden;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    &-name {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
    }
    &-gender {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      white-space: nowrap;
    }
  }
`

export default function FormCommon(props) {
  const { setValue, control, watch, bookId, setBookId, showModalBooks, setShowModalBooks } = props
  const [dataFileImported, setDataFileImported] = useState(null);
  const [dataSelect, setDataSelect] = useState(null)
  // const [canScrollLeft, setCanScrollLeft] = useState(false);
  // const [canScrollRight, setCanScrollRight] = useState(false);
  const scrollRef = useRef(null);

  // Check scroll boundaries
  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    // setCanScrollLeft(el.scrollLeft > 0);
    // setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", checkScroll);
    }
    return () => {
      if (el) el.removeEventListener("scroll", checkScroll);
    };
  }, []);

  const scrollByAmount = 200;

  const handleScrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -scrollByAmount, behavior: "smooth" });
  };

  const handleScrollRight = () => {
    scrollRef.current?.scrollBy({ left: scrollByAmount, behavior: "smooth" });
  };

  const listAvatar = [
    {
        "CharacterId": 17,
        "CharacterName": "Kumiko",
        "StandardPhoto": null,
        "StandardSquarePhoto": null,
        "Demographics": {
            "Age": 45,
            "Gender": "Female"
        },
        "Language": {
            "IsoCode": {
                "code": "en",
                "name": "English"
            }
        }
    },
    {
        "CharacterId": 19,
        "CharacterName": "Kumiko",
        "StandardPhoto": null,
        "StandardSquarePhoto": null,
        "Demographics": {
            "age": 38,
            "gender": "Female"
        },
        "Language": {
            "age": 38,
            "gender": "Female"
        }
    },
    {
        "CharacterId": 12,
        "CharacterName": "Kumiko",
        "StandardPhoto": null,
        "StandardSquarePhoto": null,
        "Demographics": {
            "age": 38,
            "gender": "Female"
        },
        "Language": {
            "code": "en",
            "name": "English"
        }
    },
    {
        "CharacterId": 10,
        "CharacterName": "Lee",
        "StandardPhoto": null,
        "StandardSquarePhoto": null,
        "Demographics": {
            "Age": 45,
            "Gender": "Female"
        },
        "Language": {
            "IsoCode": {
                "code": "en",
                "name": "English"
            }
        }
    },
    {
        "CharacterId": 8,
        "CharacterName": "Lee",
        "StandardPhoto": null,
        "StandardSquarePhoto": null,
        "Demographics": {
            "Age": 45,
            "Gender": "Female"
        },
        "Language": {
            "IsoCode": {
                "code": "en",
                "name": "English"
            }
        }
    },
    {
        "CharacterId": 11,
        "CharacterName": "Luna",
        "StandardPhoto": null,
        "StandardSquarePhoto": null,
        "Demographics": {
            "Age": 45,
            "Gender": "Female"
        },
        "Language": {
            "IsoCode": {
                "code": "en",
                "name": "English"
            }
        }
    },
    {
        "CharacterId": 3,
        "CharacterName": "Nurse Kim",
        "StandardPhoto": "https://med2lab-frontend-media.s3.amazonaws.com/media/nurse_kim-01.png",
        "StandardSquarePhoto": "https://med2lab-frontend-media.s3.amazonaws.com/media/Screen_Shot_2022-12-26_at_9.46.02_PM.png",
        "Demographics": {
            "Age": 45,
            "Gender": "Female"
        },
        "Language": {
            "IsoCode": {
                "code": "en",
                "name": "English"
            }
        }
    },
  ]

  // const Option = ({ innerProps, label }) => (
  //   <div
  //     {...innerProps}
  //     className='option-detail'
  //     style={{ padding: '8px 12px', cursor: 'pointer', display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
  //     <span className="react-select-item">{label}</span>
  //   </div>
  // );  

  const TypeUploadFile = (key) => {
    switch (key) {
      case 'Text':
        return (
          <div className='input-form'>
            <TitleNoteCommon title="Profile Image" required />
            <UploadComponent
              dataFileImported={dataFileImported}
              setDataFileImported={setDataFileImported}
              typeUpload="SVG, PNG, JPG or GIF (max. 800x400px)"
              typeFile={["image/png", "image/jpeg"]}
              errorFile="Only JPG/JPEG, PNG files are allowed."
            />
          </div>
        )
      case 'Voice':
        return (
          <>
            <div className='input-form flex-grow-1 mr-2'>
              <TitleNoteCommon title="Voice" />
              <Controller
                control={control}
                name="voice"
                defaultValue={listVoiceEngage?.[0]?.value}
                render={({ field: { onChange } }) => (
                  <Select
                    className="react-select-common w-100"
                    placeholder="Select a voice"
                    value={listVoiceEngage?.find((c) => c.value === watch("voice"))}
                    options={listVoiceEngage}
                    onChange={val => {
                      setValue("voice", val.value)
                      onChange(val.value)
                    }}
                    classNamePrefix="react-select-custom"
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                )}
              />
            </div>
            <div className='input-form'>
              <TitleNoteCommon title="Profile Image" required />
              <UploadComponent
                dataFileImported={dataFileImported}
                setDataFileImported={setDataFileImported}
                typeUpload="SVG, PNG, JPG or GIF (max. 800x400px)"
                typeFile={["image/png", "image/jpeg"]}
                errorFile="Only JPG/JPEG, PNG files are allowed."
              />
            </div>
          </>
        )
      case 'Avatar':
        return (
          <div className='input-form'>
            <TitleNoteCommon title="Avatar Character" required />
            <WrapSelectAvatar ref={scrollRef}>
              <div className='arrow-left' onClick={handleScrollLeft}>
                <Icon src={ArrowLeft}/>
              </div>
              {listAvatar?.map((item, index) => (
                <WrapItemCharacter isActive={item.CharacterId === dataSelect?.CharacterId} key={index} onClick={() => setDataSelect(item)}>
                  <div className="character__check">
                    <FormGroup check className='form-common'>
                      <Input 
                        className="react-radio-common" 
                        type="radio" 
                        name="radio"
                        checked={item.CharacterId === dataSelect?.CharacterId} 
                      />
                    </FormGroup>
                  </div>
                  <div className="character__info">
                    <div className="character__info-img">
                      <img src={item?.StandardSquarePhoto || ImageUser} alt="" />
                    </div>
                    <p className="character__info-name">{item?.CharacterName}</p>
                    <p className="character__info-gender">{item?.Demographics?.Age || item?.Demographics?.age} years old / {item?.Demographics?.gender || item?.Demographics?.Gender}</p>
                  </div>
                </WrapItemCharacter>
              ))}
              <div className='arrow-right' onClick={handleScrollRight}>
                <Icon src={ArrowRight}/>
              </div>
            </WrapSelectAvatar>
          </div>
        )
      default:
        return <></>
    }
  }
  
  return (
    <div className="formEngage__form-input">
      <div className='input-form'>
        <TitleNoteCommon title="Module Name" required />
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <Input
              type="text"
              placeholder='Name for the module (example: Childcare Assistant)'
              name='name'
              {...field}
            />
          )}
        />
      </div>
      <div className='input-form'>
        <TitleNoteCommon title="Instructions for Bot" required />
        <Controller
          name="instruction"
          control={control}
          render={({ field }) => (
            <Input
              type='textarea'
              name='instruction'
              placeholder="Detailed instructions for the AI Bot – including the role, tone, language, etc. (example: YOU are a childcare assistant who speaks in gentle tone to engage with a child at the age between 5 and 10 years old)"
              style={{ height: '80px' }}
              {...field}
            />
          )}
        />
      </div>
      <div className='input-form'>
        <TitleNoteCommon title="Opening Statement" required />
        <Controller
          name="statement"
          control={control}
          render={({ field }) => (
            <Input
              type='textarea'
              name='statement'
              placeholder="The first statement that the bot will say to start conversation (example: Hello! How are you today?)"
              style={{ height: '80px' }}
              {...field}
            />
          )}
        />
      </div>
      <div className="d-flex">
        <div className='input-form flex-grow-1 mr-2'>
          <TitleNoteCommon title="LLM Model" />
          <Controller
            control={control}
            name="model"
            defaultValue={listChatGpt?.[0]?.value}
            render={({ field: { onChange } }) => (
              <Select
                className="react-select-common w-100"
                placeholder="Select Model"
                value={listChatGpt?.find((c) => c.value === watch("model"))}
                options={listChatGpt}
                onChange={val => {
                  setValue("model", val.value)
                  onChange(val.value)
                }}
                classNamePrefix="react-select-custom"
                components={{
                  IndicatorSeparator: () => null,
                  // Option: Option
                }}
              />
            )}
          />
        </div>
        <div className='input-form flex-grow-1 ml-2'>
          <TitleNoteCommon title="Interaction Language" />
          <Controller
            control={control}
            name="interactionLanguage"
            defaultValue={interactionLanguages?.[0]?.value || "English"}
            render={({ field: { onChange } }) => (
              <Select
                className="react-select-common w-100"
                placeholder="Select a language"
                value={interactionLanguages?.find((c) => c.value === watch("interactionLanguage")) || interactionLanguages?.[0]}
                options={interactionLanguages}
                onChange={val => {
                  setValue("interactionLanguage", val.value)
                  onChange(val.value)
                }}
                classNamePrefix="react-select-custom"
                components={{
                  IndicatorSeparator: () => null,
                  // Option: Option
                }}
              />
            )}
          />
        </div>
      </div>
      <div className='input-form'>
        <TitleNoteCommon title="Interaction Method" />
        <Controller
          control={control}
          name="interactionMethod"
          defaultValue={interactionMethods?.[0]?.value || "Text"}
          render={({ field }) => (
            <div>
              {interactionMethods.map(method => (
                <FormGroup check className='form-common mr-3 mt-1' key={method.value}>
                  <Input
                    className='react-radio-common'
                    type="radio"
                    id={method.value}
                    value={method.value}
                    checked={field.value === method.value}
                    onChange={() => field.onChange(method.value)}
                  />
                  <Label check htmlFor={method.value} style={{ fontWeight: 400 }}>{method.label}</Label>
                </FormGroup>
              ))}
            </div>
          )}
        />
      </div>
      {TypeUploadFile()}
      {/* <div className='input-form'>
        <TitleNoteCommon title="Interaction Method" />
        <Controller
          control={control}
          name="interactionMethod"
          defaultValue={interactionMethods?.[0]?.value || "Text Only"}
          render={({ field: { onChange } }) => (
            <Select
              className="react-select-common w-100"
              placeholder="Select a method"
              value={interactionMethods?.find((c) => c.value === watch("interactionMethod")) || interactionMethods?.[0]}
              options={interactionMethods}
              onChange={val => {
                setValue("interactionMethod", val.value)
                onChange(val.value)
              }}
              classNamePrefix="react-select-custom"
              components={{
                IndicatorSeparator: () => null,
                // Option: Option
              }}
            />
          )}
        />
      </div> */}
      <div className='input-form'>
        <TitleNoteCommon title="Reference" />
        {bookId?.length > 0 ? (
          <BookListFile
            {...props}
            bookId={bookId}
            setBookId={setBookId}
          />
        ) : (
          <div
            className="wrap-choice__btn d-flex align-items-center justify-content-center w-100"
            onClick={() => setShowModalBooks(!showModalBooks)}
          >
            <Icon src={File} stroke="#0089C2" />
            <span>Choose from Reference Library</span>
          </div>
        )}
      </div>
    </div>
  )
}